import multiApiClient from "./base";

export const FbmArticlesApi = {
  // Cron
  startCronJob: (schedule = "0 8 * * *") =>
    Promise.resolve({
      data: { message: "Placeholder: Cron started", schedule },
    }),

  stopCronJob: () =>
    Promise.resolve({ data: { message: "Placeholder: Cron stopped" } }),

  getCronStatus: () =>
    Promise.resolve({
      data: { active: false, expression: "0 8 * * *", status: "not scheduled" },
    }),

  // Recalculate
  recalculate: (sku) =>
    multiApiClient.post(
      `/fbm/articles/recalculate/${encodeURIComponent(sku || "all")}`,
    ),

  // Sync Variation SKUS
  sync: (sku) =>
    multiApiClient.post(
      `/fbm/articles/sync/${encodeURIComponent(sku || "all")}`,
    ),

  // Export updated prices to Plenty/fbm
  exportUpdates: (sku = null) =>
    multiApiClient.post(
      "/fbm/articles/export-updates",
      null,
      sku ? { params: { sku } } : {},
    ),
};
